import type { AuditIndexItem, IndexPagination } from "@/types";
import { paginationPages } from "@/utils/pagination";

export function auditStatusDescription(audit: AuditIndexItem) {
  if (audit.status === "queued") {
    return "Warming up";
  }

  if (audit.status === "failed") {
    return "Analysis failed";
  }

  if (audit.status === "cancelled") {
    return "Analysis cancelled";
  }

  if (audit.status === "completed" && audit.analysis_complete) {
    return "Analysis complete";
  }

  return "Running analysis";
}

export function auditPaginationPages(pagination: IndexPagination) {
  return paginationPages(pagination);
}

export function auditStatusIconClasses(audit: AuditIndexItem) {
  if (audit.status === "running") return "bg-primary/20 text-primary";
  if (audit.status === "queued") return "bg-gray-100 text-gray-600";
  if (audit.status === "completed" && audit.issue_count > 0) return "bg-yellow-100 text-yellow-600";
  if (audit.status === "completed") return "bg-green-100 text-green-500";
  if (audit.status === "failed") return "bg-red-100 text-red-600";

  return "bg-orange-100 text-orange-600";
}

export function auditStatusBadgeClasses(audit: AuditIndexItem) {
  if (audit.status === "running") return "bg-primary/20 text-primary";
  if (audit.status === "queued") return "bg-gray-100 text-gray-600";
  if (audit.status === "completed" && audit.issue_count > 0) return "bg-yellow-100 text-yellow-600";
  if (audit.status === "completed") return "bg-green-100 text-green-600";
  if (audit.status === "failed") return "bg-red-100 text-red-600";

  return "bg-orange-100 text-orange-600";
}

export function auditStatusDotClasses(audit: AuditIndexItem) {
  if (audit.status === "running") return "bg-primary";
  if (audit.status === "queued") return "bg-gray-500";
  if (audit.status === "completed" && audit.issue_count > 0) return "bg-yellow-600";
  if (audit.status === "completed") return "bg-green-600";
  if (audit.status === "failed") return "bg-red-600";

  return "bg-orange-600";
}

export function auditStatusIconLabel(audit: AuditIndexItem) {
  if (audit.status === "running") return "...";
  if (audit.status === "queued") return "...";
  if (audit.status === "completed" && audit.issue_count > 0) return "!";
  if (audit.status === "completed") return "✓";
  if (audit.status === "failed") return "×";

  return "-";
}
